module.exports = __webpack_public_path__ + "static/img/12.f477aa1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/sp/12.png
// module id = rIxe
// module chunks = 0